export function SectionHeader({ label }: { label: string }) {
  return (
    <div className="px-6 py-3 border-b border-slate-200 bg-slate-50 rounded-t-xl flex-shrink-0">
      <p className="text-xs font-semibold uppercase tracking-wider text-slate-600">{label}</p>
    </div>
  );
}
